import React, { useEffect, useState } from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table, Media } from 'reactstrap';
import PatientsCallSocket from "./PatientsCallSocket";
import history from '../../history';
import SpeechComponent from "./SpeechComponent";
import MarqueesApi from '../LivingRoom/api/MarqueesApi';

let configured = false;

const PatientsCall = () => {

    const [marqueesTexts, setMarqueesTexts] = useState('');
    let patientsLatestCont = 0;

    //Se envia el Token del Usuario o si usa nueva pestaña la utiliza
    const getToken = () => {
        if (sessionStorage.getItem('token') != undefined && sessionStorage.getItem('token') != null) {
            return sessionStorage.getItem('token');
        }
        else {
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get('token');
            return token;
        }
    }

    //Se envia el Token del Usuario o si usa nueva pestaña la utiliza
    const getIdClinica = () => {
        if (sessionStorage.getItem('id_clinica') != undefined && sessionStorage.getItem('id_clinica') != null) {
            return sessionStorage.getItem('id_clinica');
        }
        else {
            const urlParams = new URLSearchParams(window.location.search);
            const id_clinica = urlParams.get('id_clinica');
            console.log(id_clinica);
            return id_clinica;
        }
    }

    let url_image = `${process.env.REACT_APP_PUBLIC_URL}clinica/${getIdClinica()}/logo/${getToken()}`;

    const [patientsCalled, setPatientsCalled] = useState([]);

    const savePatientsCalled = async (reversePatients) => {
        try {
            let called = patientsCalled.some(pat => pat.id_admision == reversePatients[0].id_admision);
            setPatientsCalled(reversePatients);
            if (!called) {
                console.log(reversePatients[0]);
                await SpeechComponent.callPatientVoice(reversePatients[0]);
            }
        }
        catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        document.body.style.backgroundColor = "#F2F4F7";
        PatientsCallSocket.emmitPatientsList();
        filterPatientsSocket();
        MarqueesFilter();
    }, []);

    const filterPatientsSocket = () => {
        PatientsCallSocket.getPatientAndSpace().then((patients) => {
            try {
                if (configured == false) {
                    if (patients.length > 0) {
                        SpeechComponent.ConfigSpeech(patients[patients.length - 1]).then(result => { configured = true });
                    }
                }
                let reversePatients = patients.reverse();
                savePatientsCalled(reversePatients);
            }
            catch (e) {
                console.log(e);
            }
        });
    }

    filterPatientsSocket();

    const clearPatientsCallSocket = () => {
        PatientsCallSocket.clearPatients().then((res) => {
            redirectBack();
        }).catch((err) => {
            redirectBack();
        });
    }

    const redirectBack = () => {
        let url_return = `${process.env.PUBLIC_URL}/pages/dashboard`;
        history.push({
            pathname: url_return
        });
    }

    const ListaLlamadas = () => {
        let _row = [];
        patientsCalled.map((item, i) => _row.push(
            <tr className="table_row shadow-sm p-3 mb-5" key={i}>
                <td className="cell-table-patients">
                    <h4 className='text-center size-table-patients'>{item?.nombre}</h4>
                </td>
                <td className="cell-table-patients">
                    <h4 className='text-center size-table-patients'>{item?.espacio}</h4>
                </td>
            </tr>
        ));
        return (
            <table className="table" style={{ width: '100%', height: '100%' }}>
                <tbody>
                    <tr style={{ backgroundColor: '#70BBFD' }} className="table_row shadow p-3 mb-5 rounded" >
                        <th className="cell-table-patients"><h4 className='text-white text-center size-table-patients'>Nombre del Paciente</h4>
                        </th>
                        <th className="cell-table-patients"><h4 className='text-white text-center size-table-patients'>Consultorio</h4></th>
                    </tr>
                    {_row}
                </tbody>
            </table>
        );
    }

    //Cierre de la Ventana
    var Cerrar = true;
    window.onbeforeunload = btncerrar();
    function btncerrar() {
        if (Cerrar == true) {
            btncerrar = false
            return "¿está seguro de salir?,  por favor guarde sus datos.";
        }
    }

    const MarqueesFilter = async () => {
        await MarqueesApi.listMarquees().then((data) => {
            let textComplete = '';
            data.map((marquees) => {
                textComplete += marquees.texto;
                textComplete += " - ";
            })
            setMarqueesTexts(textComplete);
        }).catch((err) => {
            console.log(err);
            setMarqueesTexts("");
        });
    }

    return (
        <>
            <div style={{ marginTop: '20px' }}>
                <Container className="text-center" fluid>
                    <Card className='waiting-room-card'>
                        <CardBody className="shadow p-3 mb-5 rounded">
                            <br />
                            <Row style={{height: '30px'}}>
                                <Col md={6}>
                                    <div className="waiting-room-card-image" style={{height: '10em'}}>
                                        <a onClick={() => clearPatientsCallSocket()} href='#'>
                                            <img src={url_image} style={{maxWidth: '100%', maxHeight: '100%', objectFit: 'contain'}}></img>
                                            {/* <Media object src={url_image} /> */}
                                        </a>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <span style={{ color: '#70BBFD', fontSize: '3.9vw' }}>Sala de Espera</span>
                                </Col>
                            </Row>
                            <br /><br /><br /><br />
                            <Row>
                                <Col md={12}>
                                    <Container className="text-center" fluid>
                                        <ListaLlamadas />
                                    </Container>
                                </Col>
                            </Row>
                            <br /><br /><br />
                        </CardBody>
                    </Card>
                </Container>
            </div>
            <marquee className="merquee-waiting-room">
                <label className="merquee-waiting-room-text">
                    {marqueesTexts}
                </label>
            </marquee>
        </>
    );
}
export default PatientsCall;
